import React from 'react';
import './whyrts.css';
import Navbar from '../components/NavBar';
import SEO from "../components/SEO";

const statsData = [
    {
        id: 1,
        title: "30+",
        subtitle: "Talent Acquisition",
        description: "Our expertise lies in identifying the best from across the industry based on the job descriptions of our clients. We begin the journey by understanding the client, culture and talent landscaping. Our skilled recruiters source profiles through crowd sourcing, internal"
    },
    {
        id: 2,
        title: "100+",
        subtitle: "Cloud Labs",
        description: "We provide a remote technology labs. Participants or Learners can access these labs from any part of the world. These labs provide real-time development environment and virtualized resources"
    },
    {
        id: 3,
        title: "450+",
        subtitle: "Talent development",
        description: "Rapid advancements in the technology space is forcing business and work force to adopt changes to stay competitive in the market place."
    },
];

const WhyRTS = () => {
  return (
    <div className="whyrts-page-container">
        <SEO
          title="Why RTS Techsol"
          description="Discover why organizations choose RTS Techsol for talent acquisition, cloud labs, and talent development support."
          path="/whyrts"
        />
        <Navbar />
      <h1 className="section-title-center">Why Choose RTS TECHSOL?</h1>
      
      <div className="stats-section">
        {statsData.map((stat) => (
            <div key={stat.id} className="stat-card">
                <h1>{stat.title}</h1>
                <h2>{stat.subtitle}</h2>
                <p>{stat.description}</p>
            </div>
        ))}
      </div>
      
    </div>
  );
};

export default WhyRTS;
